/*                          */
import { EventLoaderStore } from "./Store";
import { eventLoader, EventLoader } from "./Loader";
import { o_global } from "../../browser/head/namespaces.js";

declare global {
  interface OttoGlobal {
    /**
 *
 */
    eventLoaderStore?: EventLoaderStore;
  }
}

export { EventLoaderStore };
export { EventLoader, eventLoader };

/**
 *
 */
export type EventLoaderEvents = {
  /**
 *
 *
 */
  "assets.events.documentReady": [];
  /**
 *
 *
 */
  "assets.events.allJavascriptLoaded": [];
  /**
 *
 *
 */
  "assets.events.windowLoad": [originalEvent: Event];
};

o_global.EventLoader ||= EventLoader;
o_global.eventLoader ||= eventLoader();
o_global.onloadHandler ||=
  /**
 *
 *
 */
  (cb: EventListener): void => o_global.eventLoader.onLoad(100, cb);
